import { ENotificationAction } from "../actions/NotificationAction";
import { RootState } from "./RootReducer";
import { ENotificationType } from "../../Model/ENotificationType";
import { EModalNotificationAction, ModalNotificationAction } from "../actions/ModalNotificationAction";


export interface ModalNotification {
  type: ENotificationType;
  headerText:string;
  bodyTitleText:string;
  bodySubTitleText:string;
  onClickOk?:() => void;
  onClickCancel?:() => void;
  okLabel?:string;
  cancelLabel?:string;
}

interface State {
  modalNotifications: ModalNotification[];
}

const initialState: State = {
  modalNotifications: [],
};

export function modalNotificationsReducer(state = initialState, action: ModalNotificationAction): State {
  switch (action.type) {
    case EModalNotificationAction.SEND_MODAL_NOTIFICATION: {
      if (action.modalNotifications == null) {
        throw new Error("Modal Notification is null");
      }
      return {
        modalNotifications: [...state.modalNotifications, action.modalNotifications],
      };
    }
    case EModalNotificationAction.REMOVE_MODAL_NOTIFICATION: {
      const modalNotifications = [...state.modalNotifications];
      modalNotifications.splice(0, 1);
      return {
        modalNotifications: modalNotifications,
      };
    }
    default:
      return state;
  }
}

export const getModalNotifications = (state: RootState) => state.modalNotificationsStore.modalNotifications;
